import { Card, Descriptions } from 'antd'
import { useTranslation } from 'react-i18next'

import type { FulfillmentOrderRoot } from '@repo/sdk'

import { formatKrw } from '@repo/shared'
import {
  getFulfillmentOrderPaidAmount,
  getFulfillmentOrderProductAmount,
  getFulfillmentOrderShippingFee,
} from '../../lib/orderShippingAmounts'

interface PaymentInfoCardProps {
  order: FulfillmentOrderRoot
}

export function PaymentInfoCard({ order }: PaymentInfoCardProps) {
  const { t } = useTranslation()

  const total = getFulfillmentOrderPaidAmount(order)
  const shippingFee = getFulfillmentOrderShippingFee(order)
  // Separated contract serves the product amount directly; legacy order totals include shipping.
  const itemsSubtotal = getFulfillmentOrderProductAmount(order) ?? total - shippingFee

  return (
    <Card title={t('pages.orders.sections.paymentInfo')} bordered>
      <Descriptions column={1} size="small">
        <Descriptions.Item label={t('pages.orders.fields.itemsSubtotal')}>
          {formatKrw(itemsSubtotal)}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.orders.fields.shippingFee')}>
          {formatKrw(shippingFee)}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.orders.fields.totalPaymentAmount')}>
          <strong>{formatKrw(total)}</strong>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}
